window.initHeaderSearchCollection = function () {
  const el = document.querySelector('.swiper-collection-search');
  if (!el || el.swiper) return;

  if (typeof Swiper === 'undefined') {
    // The Swiper bundle is deferred; the overlay can open before it arrives.
    if (el.dataset.swiperPending) return;
    el.dataset.swiperPending = 'true';
    const retry = () => {
      delete el.dataset.swiperPending;
      window.initHeaderSearchCollection();
    };
    const bundle = document.querySelector('script[src*="swiper-bundle"]');
    if (bundle) bundle.addEventListener('load', retry, { once: true });
    window.addEventListener('load', retry, { once: true });
    return;
  }

  new Swiper(el, {
    spaceBetween: 20,
    pagination: {
      el: '.swiper-collection-search-pagination.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next.swiper-collection-search-btns__next',
      prevEl: '.swiper-button-prev.swiper-collection-search-btns__prev',
    },
    breakpoints: {
      375: {
        slidesPerView: 2,
        spaceBetween: 15,
      },
      560: {
        slidesPerView: 4,
      },
    },
  });

  const container = el.closest('[data-section-url]');
  if (container) container.dataset.ready = 'true';
};

document.addEventListener('DOMContentLoaded', window.initHeaderSearchCollection);
